importScripts('https://app3.salesmanago.pl/static/sm-sw.js');